module.exports = __webpack_public_path__ + "static/dev-9f8acd0c1806ed5e1dc3e00337b792d0.svg";